import React, {useCallback, useState} from 'react'
import CountrySelectorBanner from '../country-selector-banner'
import {DrawerMenu} from '../drawer-menu'
import {ListMenu} from '../list-menu'
import {ListMenu as BraunMenu, DrawerMenu as BraunDrawer} from '../braun-menu'
import {HideOnDesktop, HideOnMobile} from '@salesforce/retail-react-app/app/components/responsive'
import Header from '../header'
import BraunHeader from '../braun-header'
import KenwoodHeader from '../kenwood-header'
import {ListMenu as KenwoodListMenu, DrawerMenu as KenwoodDrawerMenu} from '../kenwood-menu'
import {BRAND_KEY} from '../../brand'
import {Box, useDisclosure} from '@chakra-ui/react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {useHistory} from 'react-router-dom'
import {useCurrentCustomer} from '../../hooks/use-current-customer'

const HEADER_COMPONENTS = {
    delonghi: Header,
    nutribullet: Header,
    kenwood: KenwoodHeader,
    braun: BraunHeader,
}
const LIST_MENU_COMPONENTS = {
    delonghi: ListMenu,
    nutribullet: ListMenu,
    kenwood: KenwoodListMenu,
    braun: BraunMenu,
}
const DRAWER_MENU_COMPONENTS = {
    delonghi: DrawerMenu,
    nutribullet: DrawerMenu,
    kenwood: KenwoodDrawerMenu,
    braun: BraunDrawer,
}

const MappedHeaders = HEADER_COMPONENTS[BRAND_KEY] ?? Header
const MappedListMenus = LIST_MENU_COMPONENTS[BRAND_KEY] ?? ListMenu
const MappedDrawerMenus = DRAWER_MENU_COMPONENTS[BRAND_KEY] ?? DrawerMenu

const MultisiteHeader = () => {
    const {locale, buildUrl} = useMultiSite()
    const navigate = useNavigation()
    const history = useHistory()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const [isListMenuOpen, setIsListMenuOpen] = useState(false)
    const {data: customer} = useCurrentCustomer()

    const onLogoClick = useCallback(() => {
        navigate(`/${locale?.alias}`)
        onClose()
    }, [navigate, locale?.alias, onClose])

    const onCartClick = useCallback(() => {
        const path = buildUrl('/cart')
        history.push(path)
        // Close the drawer.
        onClose()
    }, [buildUrl, history, onClose])

    const onAccountClick = useCallback(() => {
        // Link to account page if registered; Header component will show auth modal for guest users
        const path = buildUrl('/account')
        history.push(path)
    }, [buildUrl, history])

    const onWishlistClick = useCallback(() => {
        // Link to wishlist page if registered; Header component will show auth modal for guest users
        const path = customer?.isRegistered ? buildUrl('/account/wishlist') : buildUrl('/wishlist')
        history.push(path)
    }, [customer?.isRegistered, buildUrl, history])

    return (
        <Box pos="relative" zIndex={1}>
            <MappedHeaders
                onMenuClick={onOpen}
                onLogoClick={onLogoClick}
                onMyCartClick={onCartClick}
                onMyAccountClick={onAccountClick}
                onWishlistClick={onWishlistClick}
                isOpen={isOpen}
            >
                <HideOnDesktop>
                    <MappedDrawerMenus
                        isOpen={isOpen}
                        onClose={onClose}
                        onWishlistClick={onWishlistClick}
                    />
                </HideOnDesktop>

                <HideOnMobile>
                    <MappedListMenus setIsListMenuOpen={setIsListMenuOpen} />
                </HideOnMobile>
            </MappedHeaders>

            <CountrySelectorBanner isHidden={isOpen || isListMenuOpen} />
        </Box>
    )
}

export default MultisiteHeader
